import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { NodeService } from './node.service';

@NgModule({
  imports: [CommonModule, TarlV3JsonapiModule],
  providers: [NodeService],
})
export class HierarchyCommonModule {}
